import { SIGN_IN, REQUEST } from 'constants/actions';

export default function onSignIn(values, resolve, reject) {
  return { type: SIGN_IN + REQUEST, values, resolve, reject };
}
